<template>
    <div class="top_left">
        <div class="top_left_header">
            <div class="left_header_left">
                <img class="header_left_icon" src="@/assets/img/big_data/zl.png">
                <div class="header-title">监控总量</div>
                <div class="bordline"></div>
            </div>
            <div class="left_header_right">PATENT DATA</div>
        </div>
        <div id="top_left_pieChart" style="width: 300px;height: 300px;">
        </div>
        <div class="top_left_tips">
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':leftTopData[0].itemStyle.color}"></div>
                公开发明
            </div>
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':leftTopData[1].itemStyle.color}"></div>
                有效发明
            </div>
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':leftTopData[2].itemStyle.color}"></div>
                有效新型
            </div>
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':leftTopData[3].itemStyle.color}"></div>
                有效外观
            </div>
        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    name: 'LeftTop',
    props: {
        leftTopData: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        const chartContainer = document.getElementById('top_left_pieChart');
        const chart = echarts.init(chartContainer);
        const count = this.leftTopData.reduce((total, obj) => total + obj.value, 0);
        const options = {
            tooltip: {
                trigger: 'item'
            },
            legend: {
                show: false,
            },
            title: {
                zlevel: 0,
                text: [
                    '{value|' + count + '}',
                    '{name|总数}'
                ].join('\n'),
                top: 'center',
                left: '50%',
                textAlign: 'center',
                textStyle: {
                    rich: {
                        value: {
                            color: '#fff',
                            fontSize: 40,
                            fontWeight: 'bold',
                            lineHeight: 60
                        },
                        name: {
                            color: '#fff',
                            fontSize: 18,
                            lineHeight: 8,
                            fontWeight: 'bold',
                        }
                    }
                }
            },
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['52%', '90%'],
                    avoidLabelOverlap: false,
                    label: {
                        // 中间数字
                        show: true,
                        position: 'center',
                        normal: {
                            show: true,
                            position: 'center',
                            fontFamily: 'DIN Alternate',
                            formatter: function () {
                                return ''
                            },
                            textStyle: {
                                fontSize: 40,
                                fontWeight: 'bold',
                                color: '#fff',
                            },
                        },
                    },
                    emphasis: {
                        label: {
                            show: true,
                            fontSize: 40,
                            fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: this.leftTopData,
                    animation: true,
                    animationEasing: 'cubicInOut',
                    animationDuration: 2000
                }
            ]
        };
        chart.setOption(options);
        chart.on('click',function(params){
          let name = params.data.name
          localStorage.setItem('consoleType', name)
          window.open('#/patent/monitor','_blank')
        })
    }
}
</script>
<style lang="stylus" scoped>
.top_left{
    width: 411px;
    height: 450px;
    border-radius: 10px;
    border: 1px solid rgba(221, 252, 255, 0.2);
    background-color:rgba(221, 252, 255, 0.1);
    position: relative
    #top_left_pieChart{
        margin-top:19px;
        margin-left:55.5px
    }
    .top_left_tips{
        display:flex;
        justify-content:space-between;
        padding: 0 26px;
        position:absolute;
        width:100%;
        bottom:22px;
        box-sizing:border-box;
        color: #FEFEFE;
        font-weight: 400;
        font-size:12.5px;
        .tips_item{
            display:flex;
            align-items:center
        }
        .tips_item_box{
            width: 14px;
            height: 14px;
            background: #8ADE83;
            border-radius: 4px;
            margin-right:5px
        }
    }
   .top_left_header{
        display:flex;
        height:56px;
        align-items:center;
        justify-content:space-between;
        margin-left:27px;
        margin-right:29px;
        position: relative
        .bordline{
            width:100%;
            height:1px;
            background:linear-gradient(to right,rgba(0,0,0,0)0%,#9BC1FF 50%,rgba(0,0,0,0)100%);
            position:absolute;
            bottom:0
        }
   }
    .left_header_right{
        color: #B7D2FF;
        font-size: 12px;
        font-weight: 500;
        opacity: 0.2;
    }
    .left_header_left{
       
        display:flex;
        height:56px;
        align-items:center
        .header-title{
            font-size: 21px;
            font-family: 'Alimama ShuHeiTi';
            font-weight: bold;
            color: #9BC1FF;
        }
        .header_left_icon{
            width:23px;
            height:21px;
            margin-right:15px
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/console/components/LeftTop.vue